import { Component, OnInit } from '@angular/core'

@Component({
    selector: 'col-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    anoAtual: number
    urlSiteAlterdata: string

    constructor() {}

    ngOnInit() {
        this.urlSiteAlterdata = 'http://www.alterdata.com.br'

        const agora = new Date()
        this.anoAtual = agora.getFullYear()
    }
}



// WEBPACK FOOTER //
// ./src/app/footer/footer.component.ts